import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  standalone: true,
})
export class ProgressComponent {
  @Input() progress = 0;
}
